import type { ReactElement } from 'react';

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';

import type { MortgageChangeCopy } from '../model/mortgageRules';

interface Props {
  copy: MortgageChangeCopy | null;
  isLoading: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

/* Every write on this screen changes which agent answers the client, so none of them is applied
   straight from the switch. The copy is built by the model, not here. */
const MortgageConfirmDialog = ({ copy, isLoading, onCancel, onConfirm }: Props): ReactElement | null => {
  if (!copy) return null;

  return (
    <AlertDialog open>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{copy.title}</AlertDialogTitle>
          <AlertDialogDescription>{copy.description}</AlertDialogDescription>
        </AlertDialogHeader>

        <AlertDialogFooter>
          <AlertDialogCancel disabled={isLoading} onClick={onCancel}>
            Cancelar
          </AlertDialogCancel>
          <AlertDialogAction disabled={isLoading} onClick={onConfirm}>
            {isLoading ? 'Guardando...' : copy.confirmLabel}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default MortgageConfirmDialog;
